import { useContext } from "react";
import { Link } from "react-router-dom";
import { GlobalContext } from "../../../context/Provider";
import logo from '../../../assets/images/ShadowzLogo.svg'
const Header = (props) => {

  const { authState, logOutNow } = useContext(GlobalContext);

  return (
    <div class="row border-bottom sticky top-0 z-50">
      <nav
        class="navbar navbar-static-top white-bg "
        role="navigation"
        style={{ marginBottom: "0" }}
      >
        <div class="navbar-header">
          <Link
            class="navbar-minimalize minimalize-styl-2 btn btn-primary "
            to="#"
            onClick={props.toggle}
          >
            <i class="fa fa-bars"></i>{" "}
          </Link>
        </div>
        <ul className="nav navbar-top-links navbar-right align-items-center pe-3">

          {/* <li> */}
          <Link
            style={{ textDecoration: "none" }}
            to=""
            type="button"
            onClick={() => logOutNow()}
            className="sideBarColor"
          >
            <i class="fa fa-sign-out me-1"></i>{" "}
            <span class="nav-label"><b>Logout</b></span>
          </Link>
          {/* <img className="logo-img" height={30} src={logo} /> */}
          {/* <a>
              <button className="btn btn-primary" onClick={() => logOutNow()}>
                <i class="fa fa-sign-out"></i> Log out
              </button>
            </a> */}
          {/* </li> */}

        </ul>
      </nav>
    </div>
  );
};

export default Header;
